<template>
    <div class="m-portlet m--padding-10">
        <vue-card :value="value"></vue-card>
        <div class="m-portlet__body">
            <div class="form-group" :class="{'has-danger': errors.has('number') }">
                <label for="cardNo">Card No</label>
                <input type="text" name="number" v-model="value.number" class="form-control" v-validate="'required|credit_card'" data-vv-as="card number">
                <small v-show="errors.has('number')" class="form-control-feedback">{{ errors.first('number') }}</small>
            </div>
            <div class="form-group" :class="{'has-danger': errors.has('expiry') }">
                <label for="cardNo">Expiry (MM/YY)</label>
                <input type="text" class="form-control" v-model="value.expiry" name="expiry" v-validate="'required|date_format:MM / YY'" data-vv-as="expiry date">
                <small v-show="errors.has('expiry')" class="form-control-feedback">{{ errors.first('expiry') }}</small>
            </div>
            <div class="form-group" :class="{'has-danger': errors.has('cvc') }">
                <label for="cardNo">Security Code (CVC)</label>
                <input type="text" v-card-focus name="cvc" v-model="value.cvc" class="form-control" v-validate="'required:digits:3'" data-vv-as="security code">
                <small v-show="errors.has('cvc')" class="form-control-feedback">{{ errors.first('cvc') }}</small>
            </div>
        </div>
        <div class="m-portlet__foot">
            <button class="btn btn-success pull-right" :class="{ 'm-loader m-loader--light m-loader--right': loading }" @click="saveCard">
                <i class="fa fa-save"></i> Add Card
            </button>
            <div class="clearfix"></div>
        </div>
    </div>
</template>
<script>
import api from "../../../api";
import helper from "../../../helpers";
import VueCard from "vue-credit-card";

var user = JSON.parse(window.localStorage.getItem("user"));

export default {
  name: "Card",
  data() {
    return {
      loading: false,
      expiry: "",
      number: "",
      value: {
        number: "",
        name: user.firstName + " " + user.lastName,
        cvc: "",
        expiry: ""
      },
      card: {
        cardNo: "",
        cardExpiry: "",
        cardSecurityCode: "",
        token: this.$store.state.token || window.localStorage.getItem("token")
      }
    };
  },
  components: {
    VueCard
  },
  methods: {
    cardExpiry() {
      let len = this.value.expiry.length;
      if (len >= 5) {
        return (
          this.value.expiry.substring(0, 2) +
          this.value.expiry.substring(len - 2, len)
        );
      } else {
        return "";
      }
    },
    cardNumber() {
      return this.value.number.replace(/ /g, "");
    },
    saveCard() {
      this.$validator
        .validateAll()
        .then(valid => {
          if (valid) {
            this.toggleLoading();
            const txType = "add-card";
            this.card.cardNo = this.cardNumber();
            this.card.cardExpiry = this.cardExpiry();
            this.card.cardSecurityCode = this.value.cvc;
            api
              .request(txType, this.card)
              .then(response => {
                this.toggleLoading();
                if (response.data.status === "00") {
                  helper
                    .successAlert("Card has been added successfully")
                    .then(() => {
                      this.$emit('getCards');
                    });
                } else {
                  helper.errorAlert(response.data.message);
                }
              })
              .catch(error => {
                this.toggleLoading();
                helper.errorAlert(
                  "We could not establish a connection to the server. Please try again later"
                );
                console.log(error);
              });
          } else {
            console.log("Form invalid");
          }
        })
        .then(() => {
          console.log("Something went wrong");
        });
    },
    toggleLoading() {
        this.loading = this.loading ? false : true
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/billing/partial/Card.vue